export default __webpack_public_path__ + "static/media/animacion-recluta.40223668.gif";